import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPhoneLineViaID = (phoneLineId: number | undefined): Promise<IGetPhoneLineViaUnitID[]> => {
  return axiosDefaultApi.get(`/api/ComLines/GetPhoneLinesViaUnitID/${phoneLineId}`);
};

type QueryFnType = typeof getPhoneLineViaID;

type UseGetPhoneLineViaIDOptions = {
  phoneLineId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhoneLineViaID = ({ phoneLineId , config }: UseGetPhoneLineViaIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhoneLineViaID_${phoneLineId}`],
    queryFn: () => getPhoneLineViaID(phoneLineId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της τηλεφωνικής γραμμής via ID.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};